<button class="btn btn-submenu-color btn-sm" routerLinkActive="btn-submenu-active-color"
  routerLink="/admin/reports/login-attemps" *ngIf="menu.LOGIN_ATTEMPS">
  {{ 'LOGIN_ATTEMPS' | translate }}
</button>

<button class="btn btn-submenu-color btn-sm" routerLinkActive="btn-submenu-active-color"
  routerLink="/admin/reports/deleted-users" *ngIf="menu.DELETED_USERS">
  {{ 'DELETED_USERS' | translate }}
</button>

<button class="btn btn-submenu-color btn-sm" routerLinkActive="btn-submenu-active-color"
  routerLink="/admin/reports/actived-users" *ngIf="menu.REGISTER_USERS">
  {{ 'REGISTERED_USERS' | translate }}
</button>

<button class="btn btn-submenu-color btn-sm" routerLinkActive="btn-submenu-active-color"
  routerLink="/admin/reports/database-logs" *ngIf="menu.DATABASE_LOGS">
  {{ 'DATABASE_LOGS' | translate }}
</button>